import React, {useCallback} from 'react';
import styled from "styled-components";
import ChampLane from "../../../../summoner/Champ/ChampLane";
import {useHistory, useLocation} from "react-router-dom";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  height: 40px;
  width: 390px;
  margin-left: 16px;
`;
const MasteryFilterLane = ({selected}) => {
    const history = useHistory();
    const location = useLocation();

    const onClickPosition = useCallback((position) => {
        const sliceURL =location.pathname.match(/.+mastery/i)?.[0];
        history.replace(`${sliceURL}/${position.toLowerCase()}${location.search}`)
    }, [location]);
    return (
        <Wrapper>
            <ChampLane selectedLane={selected} onChangePosition={onClickPosition}/>
        </Wrapper>
    );
};

export default MasteryFilterLane;